import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./CategorySlider.css";

/* ✅ SHORT NAMES ONLY (UI SAFE) */
const categories = [
  {
    name: "Dildo",
    img: "/image/ForWomen/ForWomen1.jpg",
    link: "/women",
  },
  {
    name: "Masturbator",
    img: "/image/ForMen/ForMen18.jpg",
    link: "/men",
  },
  {
    name: "2in1",
    img: "/image/ForMen/ForMen9.jpg",
    link: "/men",
  },
  {
    name: "ButtPlug",
    img: "/image/ForWomen/ForWomen10.jpg",
    link: "/couples",
  },
  {
    name: "MiniCup",
    img: "/image/ForMen/ForMen1.jpg",
    link: "/men",
  },
  {
    name: "Doll",
    img: "/image/ForMen/ForMen7.jpg",
    link: "/men",
  },
  {
    name: "Sleeve",
    img: "/image/ForMen/ForMen16.jpg",
    link: "/men",
  },
  {
    name: "BedKit",
    img: "/image/ForWomen/ForWomen6.jpg",
    link: "/couples",
  },
];

const CategorySlider = () => {
  const sliderRef = useRef(null);

  /* ✅ AUTO SCROLL (MOBILE ONLY) */
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let scrollPos = 0;
    let interval;

    if (window.innerWidth <= 768) {
      interval = setInterval(() => {
        scrollPos += slider.offsetWidth * 0.6;
        if (scrollPos >= slider.scrollWidth - slider.clientWidth) {
          scrollPos = 0;
        }
        slider.scrollTo({ left: scrollPos, behavior: "smooth" });
      }, 2200);
    }

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="category-wrapper"
      aria-label="Shop Sex Toys Online in India by Category"
    >
      <div className="category-slider" ref={sliderRef}>
        {categories.map((item, index) => (
          <article
            key={index}
            className="category-card"
            itemScope
            itemType="https://schema.org/Product"
          >
            {/* ✅ CLICKABLE IMAGE */}
            <Link
              to={item.link}
              className="img-wrap"
              aria-label={`Buy ${item.name} Sex Toys Online in India`}
            >
              <img
                src={item.img}
                alt={`Buy ${item.name} sex toys online in India with discreet delivery from LushDesire`}
                loading="lazy"
                itemProp="image"
              />
            </Link>

            {/* ✅ SINGLE WORD H1 (SEO + UI SAFE) */}
            <h1 className="category-title" itemProp="name">
              {item.name}
            </h1>

            {/* ✅ HIDDEN SEO CONTENT */}
            <meta
              itemProp="description"
              content={`Buy ${item.name} sex toys online in India from LushDesire with 100% discreet packaging and fast delivery.`}
            />
          </article>
        ))}
      </div>
    </section>
  );
};

export default CategorySlider;
